import clsx from 'clsx';

export interface Props {
  text: string;
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  className?: string; // optional for overrides
  allowH1?: boolean; // explicitly allow rendering an H1 (defaults to false)
}

export default function Heading({
  text,
  variant,
  className,
  allowH1 = false,
}: Props) {
  // Enforce single-authorized H1 usage site-wide by requiring allowH1
  // If a component requests an H1 without explicit authorization, downgrade to H2
  const effectiveVariant = variant === 'h1' && !allowH1 ? 'h2' : variant;
  const Tag = effectiveVariant; // dynamic element name

  const sizes: Record<Props['variant'], string> = {
    h1: 'text-4xl md:text-5xl',
    h2: 'text-3xl md:text-4xl',
    h3: 'text-2xl md:text-3xl',
    h4: 'text-xl md:text-2xl',
    h5: 'text-lg',
    h6: 'text-base',
    p: 'text-base',
  };

  return (
    <Tag
      className={clsx(sizes[effectiveVariant], className)}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
}
